<template>
  <div>
    <div
      v-if="open"
      class="notification-tag-menu__overlay"
      @click="$emit('close')" />
    <div
      v-if="open"
      class="notification-tag-menu">
      <div class="notification-tag-menu__title">
        絞り込み条件の設定
      </div>
      <div class="notification-tag-menu__columns">
        <div class="notification-tag-menu__col">
          <div class="notification-tag-menu__col-label">
            #タグ1
          </div>
          <b-form-checkbox
            :checked="isAllTag1Selected"
            :indeterminate="isSomeTag1Selected"
            class="notification-tag-menu__select-all"
            @change="toggleSelectAll('tempTag1', tag1SelectableValues, isAllTag1Selected)">
            全てを選択
          </b-form-checkbox>
          <b-form-checkbox-group
            v-model="tempTag1"
            class="notification-tag-menu__checkboxes"
            :options="tag1Options"
            stacked />
        </div>
        <div class="notification-tag-menu__col">
          <div class="notification-tag-menu__col-label">
            #タグ2
          </div>
          <b-form-checkbox
            :checked="isAllTag2Selected"
            :indeterminate="isSomeTag2Selected"
            class="notification-tag-menu__select-all"
            @change="toggleSelectAll('tempTag2', tag2SelectableValues, isAllTag2Selected)">
            全てを選択
          </b-form-checkbox>
          <b-form-checkbox-group
            v-model="tempTag2"
            class="notification-tag-menu__checkboxes"
            :options="tag2Options"
            stacked />
        </div>
      </div>
      <div class="notification-tag-menu__footer">
        <button
          class="notification-tag-menu__footer-btn"
          @click="$emit('close')">
          キャンセル
        </button>
        <button
          class="notification-tag-menu__footer-btn notification-tag-menu__footer-btn--primary"
          @click="onSave">
          保存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { tag1SelectableOptions, tag2SelectableOptions } from '@/helper/tag'

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    tag1: {
      type: Array,
      default: () => [],
    },
    tag2: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tempTag1: [],
      tempTag2: [],
      tag1Options: tag1SelectableOptions,
      tag2Options: tag2SelectableOptions,
    }
  },
  computed: {
    tag1SelectableValues() {
      return this.tag1Options.map((o) => o.value)
    },
    tag2SelectableValues() {
      return this.tag2Options.map((o) => o.value)
    },
    isAllTag1Selected() {
      return this.tag1SelectableValues.every((v) => this.tempTag1.includes(v))
    },
    isAllTag2Selected() {
      return this.tag2SelectableValues.every((v) => this.tempTag2.includes(v))
    },
    isSomeTag1Selected() {
      return !this.isAllTag1Selected && this.tempTag1.length > 0
    },
    isSomeTag2Selected() {
      return !this.isAllTag2Selected && this.tempTag2.length > 0
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.tempTag1 = [...this.tag1]
        this.tempTag2 = [...this.tag2]
      }
    },
  },
  methods: {
    toggleSelectAll(key, selectableValues, isAllSelected) {
      this[key] = isAllSelected ? [] : [...selectableValues]
    },
    onSave() {
      this.$emit('save', { tag1: [...this.tempTag1], tag2: [...this.tempTag2] })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/variable';

.notification-tag-menu {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 101;
  background: $white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 16px 20px 12px;
  min-width: 345px;

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  }

  &__title {
    font-size: $fs-m;
    font-weight: bold;
    color: $grey08;
    margin-bottom: 12px;
  }

  &__columns {
    display: flex;
    gap: 24px;
  }

  &__col {
    flex: 1;
  }

  &__col-label {
    font-size: $fs-m;
    font-weight: bold;
    color: $grey08;
    margin-bottom: 8px;
  }

  &__select-all {
    margin-bottom: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid $grey10;
  }

  &__checkboxes {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, auto);
    grid-auto-flow: column;
    gap: 4px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    border-top: 1px solid $grey10;
    padding-top: 8px;
  }

  &__footer-btn {
    font-size: $fs-m;
    font-weight: bold;
    color: $l-blue;
    background: none;
    border: none;
    padding: 4px 8px;
    cursor: pointer;

    &--primary {
      color: $white;
      background-color: $l-blue;
      border-radius: 6px;
      padding: 6px 16px;
    }
  }
}
</style>
